module.exports = __webpack_public_path__ + "static/media/GuardiansPortraitBg-sm.72b7af23.jpg";